import { Outlet, useLocation } from 'react-router-dom'
import NavBar from './NavBar'
import LeftSidebar from './LeftSidebar'
import StatusRibbon from './StatusRibbon'
import HotkeysAndHelp from './HotkeysAndHelp'
import { AnimatePresence, motion } from 'framer-motion'
import React, { useState } from 'react'
import CommandPalette from './CommandPalette'
import { useTheme } from '../context/ThemeContext'
import Footer from './Footer'

export default function AppLayout() {
  const location = useLocation()
  const { reducedMotion } = useTheme()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  return (
    <div className="min-h-screen flex flex-col">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[2000] bg-white dark:bg-gray-900 border rounded px-3 py-2">Skip to content</a>
      <NavBar onToggleSidebar={() => setSidebarOpen(s => !s)} />
      <StatusRibbon />
      <HotkeysAndHelp />
      <CommandPalette />
      <div className="flex-1 flex">
        <LeftSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main id="main" className="flex-1">
        <AnimatePresence mode="wait">
          <motion.div key={location.pathname}
            initial={reducedMotion ? { opacity: 1 } : { opacity: 0, y: 8 }}
            animate={reducedMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
            exit={reducedMotion ? { opacity: 1 } : { opacity: 0, y: -8 }}
            transition={reducedMotion ? { duration: 0 } : { duration: 0.18, ease: 'easeOut' }}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
        </main>
      </div>
      <Footer />
    </div>
  )
}
